<div class="work-ui-form-wizard">
  <div class="work-grid-container">
    <div class="work-grid-row work-grid-row--with-borders work-grid-row--with-borders-no-padding">
      <div class="work-grid-col work-grid-col-desktop-4 work-grid-col-tablet-12 work-grid-col-mobile-12">
        <work-ui-progress-steps [activeStep]="progressStepListActiveIndex()"
                                [steps]="progressStepList()"
                                alignment="vertical" />
      </div>
      <div class="work-grid-col work-grid-col-desktop-8 work-grid-col-tablet-12 work-grid-col-mobile-12">
        <work-ui-visual-scroll-indicator theme="light">
          <div class="work-ui-form-wizard__step-content">
            <div class="margin-bottom-24">
              @if (currentStep(); as step) {
                @if (step.stepTitle(); as stepTitle) {
                  <h3>{{ stepTitle | translate }}</h3>
                }
              }
            </div>

            <ng-template #stepHost></ng-template>
          </div>
        </work-ui-visual-scroll-indicator>

        <div class="work-ui-form-wizard__nav-buttons work-buttons work-buttons--space-between padding-top-24">
          <div>
            @if (currentIndex() !== 0) {
              <work-ui-button (buttonClick)="prev()"
                              text="ZURUECK"
                              variant="secondary" />
            }
          </div>

          <div>
            @if (currentIndex() === steps().length - 2 && steps()[currentIndex() + 1].stepHidden() || currentIndex() === steps().length - 1) {
              <div class="flex gap-16">
                <ng-content select="[wizard-footer-end]"></ng-content>
                <work-ui-button (buttonClick)="complete.emit()"
                                [disabled]="!formGroupInput().valid || completeButtonDisabled()"
                                [loadingState]="completeButtonLoadingState()"
                                [text]="completeButtonLabel()" />
              </div>
            } @else {
              <work-ui-button (buttonClick)="next()"
                              [disabled]="!isCurrentStepValid()"
                              [text]="currentStep()?.stepButtonNextText() || 'WEITER'" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
